import gql from 'graphql-tag';
import apollo from '../apollo';
import { getEntityListWithAccount } from '../../utils/AppUtil';

const ADD_NEW_ASSESSMENT_TEMP = gql`
  mutation($input: CreateAssessmentTemplateInput!) {
    createAssessmentTemplate(input: $input) {
      template {
        id
      }
    }
  }
`;

export const addAssessmentTempMutate = input => apollo
  .mutate({
    mutation: ADD_NEW_ASSESSMENT_TEMP,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const UPDATE_ASSESSMENT_TEMP = gql`
  mutation updateAssessmentTemplate($input: UpdateAssessmentTemplateDetailsInput!) {
    updateAssessmentTemplateDetails(input: $input) {
      template {
        id
        title
        inviteTemplateId
        thankYouTemplateId
        reminderTemplateId
        feedbackTemplateId
      }
    }
  }
`;

export const updateAssessmentTempMutate = input => apollo
  .mutate({
    mutation: UPDATE_ASSESSMENT_TEMP,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const ASSESSMENT_TEMP = gql`
  query assessmentTemp(
    $accountId: ID!
    $first: Int!
    $filter: AssessmentTemplateFilter
    $sort: AssessmentTemplateSortSpecifier
  ) {
    account(id: $accountId) {
      id
      assessmentTemplates(first: $first, filter: $filter, sort: $sort) {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;

export const searchAsmtTemp = ({ aid, query }) => {
  const sort = {
    sortBy: 'title',
    sortDir: 'ASC',
  };

  const variables = {
    accountId: aid,
    first: 1000,
    filter: {
      query,
    },
    sort,
  };

  return apollo
    .query({
      query: ASSESSMENT_TEMP,
      variables,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const { account } = data;
      const processed = getEntityListWithAccount(account, 'assessmentTemplates');
      return processed;
    });
};
